import { useCallback } from 'react'

import {
  createSalesFunnel,
  getSalesFunnelForEdit,
} from '@user/store/salesFunnel/api'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { toast } from '@sales-center/components'
import { updateLoadingState } from '@sales-center/common'
import { toCreateModel, toStoreModel } from '@user/store/salesFunnel/editSlice'
import { unwrapResult } from '@reduxjs/toolkit'
import { isAPIError } from '@user/store/services/crud'

export const useDuplicateSalesFunnel = () => {
  const dispatch = useAppDispatch()

  const onClickDuplicateFunnel = useCallback(
    async (id: string) => {
      try {
        dispatch(updateLoadingState('visible'))
        const response = await dispatch(getSalesFunnelForEdit(id))

        if (getSalesFunnelForEdit.fulfilled.match(response)) {
          const { funnel, sections, stages, reasons } = toStoreModel(
            response.payload,
          )
          const duplicateModel = toCreateModel(
            '',
            'DUPLICATED ' + funnel.name,
            funnel.allowOtherReasons,
            sections,
            stages,
            reasons,
          )

          const result = await dispatch(createSalesFunnel(duplicateModel))

          if (createSalesFunnel.fulfilled.match(result)) {
            dispatch(updateLoadingState('hidden'))
            toast.success('Sales funnel duplicated successfully.')
          } else {
            dispatch(updateLoadingState('hidden'))
            unwrapResult(result)
          }
        } else {
          dispatch(updateLoadingState('hidden'))
          unwrapResult(response)
        }
      } catch (error) {
        dispatch(updateLoadingState('hidden'))
        if (isAPIError(error)) {
          toast.error(error.Message)
        } else {
          toast.error('Unable to duplicate sales funnel')
        }
      }
    },
    [dispatch],
  )

  return { onClickDuplicateFunnel }
}
